const DEFAULT_WORKFLOW_ERROR =
  "Error updating workflow. Please try again or contact support@aptihealth.com if the issue persists.";

const DEFAULT_SIGNUP_ERROR =
  "Error occurred while completing sign up. Please try again or contact support@aptihealth.com if the issue persists.";

const DEFAULT_REFERRAL_ERROR =
  "Error occurred while completing referral. Please try again or contact support@aptihealth.com if the issue persists.";

export const ERROR_CODE_MAP = {
  "Captcha verification failed": {
    code: "EC400CAP", // Captcha failure 400
    message: "Captcha verification failed. Please try again.",
  },
  "Exception occurred during referral attempt": {
    code: 400,
    message: DEFAULT_REFERRAL_ERROR,
  },
  "Exception occurred during signup": {
    code: 400,
    message: DEFAULT_SIGNUP_ERROR,
  },
  "Incomplete practice configuration": {
    code: "EPRC", // Error Practice Configuration
    message:
      "Unable to complete referral due to a practice configuration issue. Please contact support@aptihealth.com.",
  },
  "Invalid Code": {
    code: "EC401C", // Invalid referral Code 401
    message: "The referral code is invalid. Please contact your provider.",
  },
  WorkflowDefault: {
    code: "EUNK",
    message: DEFAULT_WORKFLOW_ERROR,
  },
};
